import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter, map, startWith } from 'rxjs';
import { DEFAULT_BANNER, MerchantContext } from '../core/services/merchant-context';

@Component({
  selector: 'app-shell',
  imports: [RouterOutlet],
  host: { class: 'flex  min-h-screen max-w-2xl w-full flex-col  mx-auto px-5 py-10 bg-[#F8F8F8]' },
  template: `
    <header class="bg-white shadow-[0px_0px_12px_0px_rgba(0,0,0,0.16)]">
      <div>
        <img [src]="bannerUrl()" alt="ASIATIQUE logo" class="aspect-[16/9] w-full h-full " />
      </div>
    </header>
    <router-outlet></router-outlet>
  `,
})
export class Shell {
  private merchantContext = inject(MerchantContext);
  private router = inject(Router);

  /**
   * The merchant-specific banner is shown on /showcode/:merchantName and on the
   * /:merchantName?redeem=true success page; every other route uses the default banner.
   */
  private showMerchantBanner = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map((event) => this.isMerchantBannerUrl(event.urlAfterRedirects)),
      startWith(this.isMerchantBannerUrl(this.router.url)),
    ),
    { initialValue: this.isMerchantBannerUrl(this.router.url) },
  );

  bannerUrl = computed(() =>
    this.showMerchantBanner() ? this.merchantContext.bannerUrl() : DEFAULT_BANNER,
  );

  private isMerchantBannerUrl(url: string): boolean {
    const [path, query] = url.split('?');
    if (path.startsWith('/showcode')) return true;
    return new URLSearchParams(query ?? '').get('redeem') === 'true';
  }
}
